<template>
  <div class="server-room" :style="{ backgroundImage: `url(${bg})` }">
    <div class="text-container">
      <h1 class="construction-text">Sitio en Construcción 🚧</h1>
      <p class="subtext">¡Vuelve pronto!</p>
    </div>
  </div>
</template>

<script>
import { onMounted } from 'vue';
import bg from '@/assets/bg.webp';

export default {
  name: 'HelloWorld',
  setup() {
    onMounted(async () => {
      const { gsap } = await import('gsap'); // Importación dinámica
      gsap.from(".construction-text", { opacity: 0, y: -50, duration: 1.5, ease: "power2.out" });
      gsap.from(".subtext", { opacity: 0, y: 50, duration: 1.5, delay: 0.5, ease: "power2.out" });
    });
    return { bg };
  }
};
</script>

<style scoped>
@font-face {
  font-family: 'Orbitron';
  src: url('@/assets/fonts/Orbitron-Bold.ttf') format('truetype');
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  width: 100%;
  height: 100%;
  overflow: hidden;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  touch-action: manipulation;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
}

.server-room {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.text-container {
  background: rgba(0, 0, 0, 0.5);
  padding: 30px;
  border-radius: 15px;
  max-width: 90%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  word-break: normal;
  overflow-wrap: normal;
  white-space: normal;
}

.construction-text {
  font-size: clamp(2rem, 5vw, 3.5rem);
  color: #00ffff;
  font-weight: bold;
  font-family: 'Orbitron', sans-serif;
  text-shadow: 0px 0px 50px rgba(0, 255, 255, 1), 0px 0px 20px rgba(0, 255, 255, 0.9);
  animation: pulse 1.5s infinite alternate;
}

.subtext {
  font-size: clamp(1rem, 3vw, 1.5rem);
  color: #ffffff;
  font-family: 'Orbitron', sans-serif;
  opacity: 1;
  margin-top: 10px;
  letter-spacing: 1px;
  text-shadow: 0px 0px 20px rgba(255, 255, 255, 1);
}

@keyframes pulse {
  0% { transform: scale(1); }
  100% { transform: scale(1.05); }
}

@media (max-width: 768px) {
  .text-container {
    max-width: 75%;
    padding: 20px;
  }
  .construction-text {
    font-size: 3rem;
  }
}

@media (max-width: 480px) {
  .text-container {
    max-width: 85%;
    padding: 15px;
  }
  .construction-text {
    font-size: 2rem;
  }
  .subtext {
    font-size: 1rem;
  }
}
</style>
